var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-fixed"},[_c('div',{staticClass:"footer-content"},[_c('p',[_vm._v(" © 2025 Digital Twin Hub. All rights reserved. | 致力于推动数字孪生技术发展 | "),_c('span',{staticClass:"icp-info"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("京ICP备2025153900号-1")])])])])])
}]

export { render, staticRenderFns }